import React, { useState, useEffect } from 'react';
import Botonsubseccion from '../V2/Valvulas/Componentes/BotonSubseccion';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import Verifiers from '../../../../utils/Verifiers.jsx';
import TablaCatalogos from './components/TablaCatalogos';
import Post from '../../../../utils/Post';
import AgregarBlancoBiologico from './components/AgregarBlancoBiologico';
import AgregarCatalogoPlagaEnfermedad from './components/AgregarCatalogoPlagaEnfermedad';
import AgregarClasificacion from './components/AgregarClasificacion';
import AgregarProductoFumigacion from './components/AgregarProductoFumigacion';
import AgregarTratamiento from './components/AgregarTratamiento';
import AgregarRelacionesFlorBB from './components/AgregarRelacionesFlorBB';

const VirusEnfermedadesCatalogo = () => {
    const subsecciones = ["Catálogo plagas y enfermedades", "BB-productos relación", "Blancos biológicos", "Productos de fumigación", "Clasificaciones", "Flores y Blancos biológicos"];
    const [section, setsection] = useState(subsecciones[0]);
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [agregar, setagregar] = useState({ show: false, data: null });
    const [FB_editor, setFB_editor] = useState({});
    const [flores, setflores] = useState([]);
    const [data, setdata] = useState({ "Catálogo plagas y enfermedades": [], "BB-productos relación": [], "Blancos biológicos": [], "Productos de fumigación": [], "Clasificaciones": [] });
    const [heads, setheads] = useState({
        "Catálogo plagas y enfermedades": [
            "Blanco biológico",
            "Descripción",
            "Clasificación",
            "Forma de evaluación",
            "Severidad G1",
            "Severidad G2",
            "Severidad G3"
        ],
        "Blancos biológicos": ["Nombre", "Descripción", "Folio"],
        "Clasificaciones": ["Folio", "Clasificación"],
        "Productos de fumigación": ["Nombre", "Dosis", "UM dosis", "Ing. activo", "Clasificación", "Meca. acción", "Categoría toxicológica", "Costo dosis", "Horas R. E."],
        "BB-productos relación": ["Blanco biológico", "Descripción", "Producto", "Dosis", "Actualizado"],
        "Flores y Blancos biológicos": []
    });
    const [keys, setkeys] = useState({
        "Catálogo plagas y enfermedades": [
            "blanco_biologico",
            "blanco_biologico_descripcion",
            "clasificacion",
            "forma_evaluacion",
            "severidadG1", "severidadG2", "severidadG3"],
        "Blancos biológicos": ["nombre", "descripcion", "id"],
        "Clasificaciones": ["id", "clasificacion"],
        "Productos de fumigación": ["nombre", "dosis", 'um_dosis', "ingrediente_activo", "clasificacion", "mecanismo_accion", "categoria_toxicologica", "costo_dosis", "horas_r_e"],
        "BB-productos relación": ["blanco_biologico", "descripcion", "producto", "dosis", "fecha_actualizacion"],
        "Flores y Blancos biológicos": [],
    });
    const anchoTabla = {
        "Catálogo plagas y enfermedades": "bw-1700",
        "Blancos biológicos": "bw-1000",
        "Clasificaciones": "bw-800",
        "Productos de fumigación": "bw-1700",
        "BB-productos relación": "bw-1200",
        "Flores y Blancos biológicos": "bw-1700"
    }

    const cerrarHijo = (update) => {
        if (update) {
            updateData(update);
        }
        setagregar({ show: false, data: null });
    }

    const editorRegistro = () => {
        if (section === "Catálogo plagas y enfermedades") {
            return <AgregarCatalogoPlagaEnfermedad
                data={agregar.data}
                close={cerrarHijo}
                title={section}
                clasificaciones={data['Clasificaciones']}
                blancosBiologicos={data['Blancos biológicos']}
            />
        }
        if (section === "Blancos biológicos") {
            return <AgregarBlancoBiologico data={agregar.data} close={cerrarHijo} title={section} />
        }
        if (section === "Clasificaciones") {
            return <AgregarClasificacion data={agregar.data} close={cerrarHijo} title={section} />
        }
        if (section === "Productos de fumigación") {
            return <AgregarProductoFumigacion data={agregar.data} close={cerrarHijo} title={section} />
        }
        if (section === "BB-productos relación") {
            return <AgregarTratamiento
                data={agregar.data}
                close={cerrarHijo}
                title={section}
                productos={data['Productos de fumigación']}
                blancosBiologicos={data['Blancos biológicos']} />
        }
        if (section === "Flores y Blancos biológicos") {
            let edicion = agregar.data ? true : false;
            let FB_editor_single = null;
            let flores_diponibles = [];
            if (edicion) {
                let flor = agregar.data.flor;
                let BBs = FB_editor[flor.id];
                let blancos_biologicos = {};
                try {
                    BBs.forEach((BB) => { blancos_biologicos[BB] = BB });
                } catch (error) {
                    blancos_biologicos = {};
                }

                FB_editor_single = { flor: flor.id, blancos_biologicos: blancos_biologicos }
                flores_diponibles = [flor];
            } else flores_diponibles = [...flores];

            return <AgregarRelacionesFlorBB
                title={section}
                FB_editor={FB_editor_single}
                flores={flores_diponibles}
                blancos_biologicos={data['Blancos biológicos']}
                close={cerrarHijo} />
        }
    }

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        let resp = await Post('mipe/catalogo/get', {}, 'POST', setloader);
        if (!resp.estatus) {
            Verifiers.activeDialog(setdialog, resp.msj, 'Ocurrió un problema', 'error');
            return;
        }
        updateData(resp.data);
    }

    const updateData = (data) => {
        setheads({ ...heads, "Flores y Blancos biológicos": data.FB_heads });
        setkeys({ ...keys, "Flores y Blancos biológicos": data.FB_keys });
        setFB_editor(data.FB_editor);
        setflores(data.flores);
        let catalogos = ["Catálogo plagas y enfermedades", "BB-productos relación", "Blancos biológicos", "Productos de fumigación", "Clasificaciones", "Flores y Blancos biológicos"];
        let newData = {};
        catalogos.forEach((catalogo) => { newData[catalogo] = data[catalogo] });
        setdata(newData);
    }

    return (
        <div className='w-100 overflow bg-white m-0 p-1 overflow relative border round-m shadow-sm dosis' style={{ height: "calc(100vh - 60px)" }}>
            <div className='w-100 m-0 p-0'>
                <div className='row justify-content-start w-100 m-0 p-0'>
                    <div className='form-group bw-300'>
                        <label className='text-bold text-xs w-100 m-0 p-0 ps-3'>Selector de catálogo</label>
                        <select className='form-control form-control-sm border border-2 round-m text-bold' onChange={(e) => setsection(e.target.value)}>
                            {subsecciones.map((subseccion, index) => <option value={subseccion} key={"vl" + index}>{subseccion}</option>)}

                        </select>
                    </div>
                    <div className='col-auto contenedor-bottom '>
                        <button className='btn mt-2 btn-sm btn-light shadow text-bold round-xxl border-3 border-warning' onClick={() => setagregar({ show: true, data: null })}>
                            Agregar
                            <span className='text-300 text-s ms-1'>{section}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 m-0 p-0'></div>
                <div className={`p-2 round-s border-3 shadow-sm mt-2 ${anchoTabla[section]}`} style={{ overflow: 'auto', maxHeight: "83vh", transition: "width 0.5s ease-in-out" }}>
                    <TablaCatalogos
                        heads={heads[section]}
                        keys={keys[section]}
                        data={data[section]}
                        tableBordered={section === "Flores y Blancos biológicos"}
                        stickyFirts={section === "Flores y Blancos biológicos"}
                        editFunction={(data) => setagregar({ show: true, data: data })} />
                </div>
            </div>
            {agregar.show && editorRegistro()}
            {loader && ldr}
            <VainillaDialog dialog={dialog} />
        </div>
    )
}

export default VirusEnfermedadesCatalogo;